export const PARENT_PRODUCTS = {
	CONFLUENCE: 'confluence',
	JIRA: 'jira',
} as const;

export interface PanelDataMap {
	actions?: {
		expand: () => void;
	};
	embedUrl?: string;
}
